<div class="app">
  <app-sidenav (notifyDisplayFunc)="notifyDisplay($event)"></app-sidenav>
  <main [ngClass]="{ 'display-padding': displaySidenav }">
    <app-breadcrumb></app-breadcrumb>
    <router-outlet></router-outlet>
  </main>
</div>
